import { Divider, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from '../../../../../common/hooks'
import { BoxWithLabel } from '../../../../../common/components/BoxWithLabel'
import { ReferralBaseInfo } from '../../types/patientReferrals.types'
import { ReferralPatientDetails } from './ReferralPatientDetails'
import { ProfessionSelector } from '../../../../../common/components/selectors/ProfessionSelector'
import { TextfieldController } from '../../../../../common/components/controllers/TextfieldController'
import { DatePickerController } from '../../../../../common/components/controllers/DatePickerController'
import { ReferralDoctorDetails } from './ReferralDoctorDetails'

interface ReferralDetailsStepProps {
  referralBaseInfo: ReferralBaseInfo
}
const ReferralDetailsEditStep: React.FC<ReferralDetailsStepProps> = ({
  referralBaseInfo,
}) => {
  const { t } = useTranslation()

  return (
    <Stack gap={2}>
      <Typography variant="body2">
        {t('doctor:referralDetails.subtitle')}
      </Typography>

      <ReferralPatientDetails referralBaseInfo={referralBaseInfo} />

      <Divider />

      <Grid container columnSpacing={2} rowSpacing={0}>
        <Grid item xs={6}>
          <TextfieldController
            name="logNumber"
            label={t('doctor:referralDetails.logNumber')}
            rules={{ required: true }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextfieldController
            name="description"
            label={t('doctor:referralDetails.disease')}
            rules={{ required: true }}
            multiline
            minRows={3}
          />
        </Grid>

        <Grid item xs={6}>
          <DatePickerController
            name="expirationDate"
            label={t('doctor:referralDetails.expirationDate')}
            rules={{ required: true }}
          />
        </Grid>

        <Grid item xs={12}>
          <BoxWithLabel label={t('doctor:referralDetails.profession')}>
            <ProfessionSelector name="profession" multiple={false} />
          </BoxWithLabel>
        </Grid>

        <Grid item xs={3}>
          <TextfieldController
            name="createdAtPlace"
            label={t('doctor:referralDetails.place')}
            rules={{ required: true }}
          />
        </Grid>

        <Grid item xs={4}>
          <DatePickerController
            name="createdAtDate"
            label={t('doctor:referralDetails.date')}
            rules={{ required: true }}
          />
        </Grid>

        <Grid item xs={5}>
          <ReferralDoctorDetails referralBaseInfo={referralBaseInfo} />
        </Grid>
      </Grid>
    </Stack>
  )
}

export { ReferralDetailsEditStep }
